import { render, staticRenderFns } from "./lawyerRegister.vue?vue&type=template&id=c1149956&scoped=true"
import script from "./lawyerRegister.vue?vue&type=script&lang=js"
export * from "./lawyerRegister.vue?vue&type=script&lang=js"
import style0 from "./lawyerRegister.vue?vue&type=style&index=0&id=c1149956&prod&lang=less&scoped=true"
import style1 from "./lawyerRegister.vue?vue&type=style&index=1&id=c1149956&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1149956",
  null
  
)

export default component.exports